/**
 * 要素にマウスオーバーしたときに、要素上部に吹き出しスタイルでテキストを表示します。ブロック要素に対して利用できます。
 * 吹き出しは要素内にprependされます。
 *
 * Updated: 2023/09/30
 *
 * @param {HTMLElement} element - 対象のHTML要素。
 * @param {Object} options - 設定オプション。
 * @param {String} options.html - ヒントに表示するコンテンツを指定します。デフォルトは空文字。
 *
 * 使用方法:
 * const targetElement = document.querySelector('.target');
 * mtapp.showHint(targetElement, { html: 'ヒントメッセージ' });
 */
export function showHint(element, options = {}) {
    const op = { ...{ html: '' }, ...options };

    if (options.text && !options.html) {
        op.html = options.text;
    }

    const balloon = document.createElement('div');
    balloon.classList.add('balloon', 'd-none');

    const balloonContent = document.createElement('div');
    balloonContent.classList.add('balloon-content');
    balloonContent.innerHTML = op.html;
    balloon.appendChild(balloonContent);

    const balloonArrow = document.createElement('div');
    balloonArrow.classList.add('balloon-arrow');
    for (let i = 10; i >= 1; i--) {
        const line = document.createElement('div');
        line.classList.add(`line${i}`);
        balloonArrow.appendChild(line);
    }
    balloon.appendChild(balloonArrow);

    element.prepend(balloon);

    element.addEventListener('mouseenter', function () {
        balloon.classList.remove('d-none');
        balloon.classList.add('d-block');
        balloon.style.marginTop = `-${balloon.offsetHeight}px`;
    });

    element.addEventListener('mouseleave', function () {
        balloon.classList.add('d-none');
        balloon.classList.remove('d-block');
    });
}
